module.exports = __webpack_public_path__ + "img/additional-co-editor.05d8057e.svg";